export default "https://cdn-static.gokick.com/assets/c9d0de51336abe1332e753a6383b3531473fb45b/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";